import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import DynamicQuantitySelect from 'dibs-dynamic-quantity-select';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';
import get from 'lodash.get';

import styles from './PdpSharedButtons.scss';
const SHOW_CUSTOM_QUANTITY_AMOUNT = '31';

class PdpSharedQuantitySelect extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            selectedQuantity: '1',
        };
    }

    onChange(e) {
        const { value } = e.target;

        this.setState({
            selectedQuantity: value,
        });
    }

    isValidCtaQuantity() {
        const { item } = this.props;
        const { hasUnlimitedQuantity, quantity } = item;
        const { selectedQuantity } = this.state;
        return hasUnlimitedQuantity || Number(selectedQuantity) <= quantity;
    }
    render() {
        const { children, intl, item } = this.props;
        const { selectedQuantity } = this.state;
        const { isDeleted, isSold, quantitySelectOptions, seller, setSize } = item;
        const ctaQuantity = this.isValidCtaQuantity() ? selectedQuantity : '1';

        if (quantitySelectOptions) {
            const messages = defineMessages({
                placeholder: {
                    id: 'PdpSharedQuantitySelect.placeholder',
                    defaultMessage: 'Quantity',
                },
            });

            const input = (
                <DynamicQuantitySelect
                    availableQuantity={item.quantity}
                    hasAnimatedPlaceholder
                    intl={intl}
                    onChange={this.onChange}
                    value={selectedQuantity}
                    options={quantitySelectOptions}
                    soldAsSet={setSize && setSize > 1}
                />
            );

            const sellerIsActive = get(item, 'seller.status') === 'active';
            const sellerIsInternal = get(item, 'seller.status') === 'internal';
            const showQuantitySelect =
                (sellerIsActive || sellerIsInternal) && !isDeleted && !isSold;

            return (
                <div>
                    <div className={styles.quantitySelectWrapper} data-tn="quantity-select-wrapper">
                        {showQuantitySelect ? input : null}
                    </div>
                    {children(ctaQuantity)}
                </div>
            );
        } else {
            return children(null);
        }
    }
}

PdpSharedQuantitySelect.propTypes = {
    item: PropTypes.object.isRequired,
    children: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
};

export default createFragmentContainer(injectIntl(PdpSharedQuantitySelect), {
    item: graphql`
        fragment PdpSharedQuantitySelect_item on Item {
            quantity
            hasUnlimitedQuantity
            quantitySelectOptions {
                label
                value
            }
            setSize
            isSold
            isDeleted
            seller {
                status
            }
        }
    `,
});
